module.exports = __webpack_public_path__ + "img/categories-pillows.c446569.png";